import React, { useState, useRef } from "react";

const Scholarship = () => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const apiURL = "https://531lqrgmkc.execute-api.us-east-2.amazonaws.com/prod";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmissionStatus(null);

    try {
      const formData = new FormData(formRef.current);
      const formDataObject = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      const response = await fetch(apiURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDataObject),
      });

      if (response.ok) {
        setSubmissionStatus("success");
        if (formRef.current) { //added check
          formRef.current.reset();
        }
      } else {
        setSubmissionStatus("error");
      }
    } catch (err) {
      console.error(err);
      setSubmissionStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="scholarship">
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        name="save-google-sheet"
        id="save-google-sheet"
        className=""
      >
        <div className="status">
          {submissionStatus === 'error' && (
            <p className="error" style={{ color: "red" }}>Form submission failed.</p>
          )}
          <p className="thanks">
            {loading ? "Loading..." : ""}
          </p>
          <p className="thanks">
            {submissionStatus === 'success' ? "Thank you for registering or the schlolarship, Winner will be notified by July 8th" : " "}
          </p>
        </div>
        <h2 className="">Conference Scholarship</h2>
        <p className="info">
         OCD New York is pleased to announce a scholarship opportunity for residents of NEW YORK STATE to cover the cost of VIRTUALLY attending the 30th Annual OCD Conference from July 10-13, 2025. A total of 15 scholarships will be given away to cover the cost of the virtual registration fee for those who have lived experience with OCD and related disorders and/or their loved ones. The scholarship provides funding for those who are unable to attend the conference due to financial reasons.
        </p>
        <p className="info">
        This year’s conference will be offering 86 sessions streamed live from Chicago and access to recordings for 60 days afterwards. 
        </p>
        <p className="info">
        To apply for a scholarship, please complete the form below and provide a brief description of why you or your loved ones would like to attend the conference and how a scholarship would help you (under 250 words).
        </p>
        <p className="info">
        Application forms should be submitted by midnight on June 20th, 2025. Recipients will be notified by June 25th.
        </p>
        <p className="info">
          For more information on the conference, <a href="https://iocdf.org/event/international-ocd-foundation-annual-conference/" target="_blank">click here</a>.
        </p>
        <div className="fields">
          <div className="name">
            <div className="first">
              <label htmlFor="first_name">First Name</label>
              <input className="side" type="text" id="first_name" name="first_name" placeholder="" />
            </div>
            <div className="last">
              <label htmlFor="last_name">Last Name</label>
              <input className="side" type="text" id="last_name" name="last_name" placeholder="" />
            </div>
          </div>
          <div className="email">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" placeholder="" />
          </div>
          <div className="radio-group">
            <label>Are you a New York State resident?</label><br />
            <input type="radio" id="new_york_resident_yes" name="new_york_resident" value="yes" />
            <label htmlFor="new_york_resident_yes">Yes</label><br />
            <input type="radio" id="new_york_resident_no" name="new_york_resident" value="no" />
            <label htmlFor="new_york_resident_no">No</label>
          </div>
          <div className="radio-group">
            <label>Are you an individual with OCD or a family member of an individual with OCD?</label><br />
            <input type="radio" id="ocd_yes" name="ocd_related" value="yes" />
            <label htmlFor="ocd_yes">Yes</label><br />
            <input type="radio" id="ocd_no" name="ocd_related" value="no" />
            <label htmlFor="ocd_no">No</label>
          </div>
          <div className="comment-group">
            <label htmlFor="comment">Please describe why you or your support system would like to attend the conference and how a scholarship could help make that happen.</label>
            <textarea id="comment" name="comment" placeholder="" />
          </div>
        </div>
        <div className="submit">
          <input
            className="button"
            type="submit"
            value={loading ? "Loading..." : "Submit"}
          />
        </div>
      </form>
    </div>
  );
};

export default Scholarship;